import { render, staticRenderFns } from "./Simposium.vue?vue&type=template&id=43ca5539"
import script from "./Simposium.vue?vue&type=script&lang=js"
export * from "./Simposium.vue?vue&type=script&lang=js"
import style0 from "./Simposium.vue?vue&type=style&index=0&id=43ca5539&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports